import { eHinhThucThanhToanActionTypeDefine } from "../../action-types/category/IHinhThucThanhToanActionType";
import { generateActions } from "../generateActions";

export const hinhThucThanhToanActions = {
    ...generateActions(eHinhThucThanhToanActionTypeDefine, "HINH_THUC_THANH_TOAN"),
}